export default __webpack_public_path__ + "static/media/Real-Time Bluedot Wayfinding.4a1316d2.svg";